import React, { useEffect, useState } from "react";
import { FaFacebook, FaInstagram } from "react-icons/fa";
import { FaXTwitter } from "react-icons/fa6";
import "./Footer.css";
import { Logo1, Logo2 } from "../../Assests/Assests";
// import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import CountdownTimer from "../DynamicCountdown";
import { IoLogoPinterest } from "react-icons/io5";

const Footer = () => {
  const [timeLeft, setTimeLeft] = useState({
    days: 182,
    hours: 12,
    minutes: 15,
    seconds: 45,
  });

  const [email, setEmail] = useState("");

  //   const [sendEmail,setSendEmail] = useState('');

  //   console.log(sendEmail,"send Email")
  // const emailHandle = async () => {
  //   if(
  //     sendEmail === ""
  //   )
  //   {
  //   Swal.fire("Please enter your email");
  //   }
  // }

  // useEffect(() =>{
  //   if(sendEmail !== "")
  //   {
  //     emailHandle()

  //   }
  // },[sendEmail])/api/v1/user/subscribe/email
  const handleSubscribe = async () => {
    if (!email) {
      // ✅ Check if email is empty before making a request
      toast.error("Please enter a valid email address before subscribing.", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        toastId: "emptyEmail", // ✅ Prevent duplicate toasts
      });
      return;
    }

    try {
      const response = await fetch(
        `https://riymay.com/api/v1/user/subscribe/email`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
          body: JSON.stringify({ email }),
        }
      );

      if (response.ok) {
        // ✅ Fixed success condition (it should be if response is OK)
        toast.success(
          "Thank you for subscribing! You'll receive updates soon.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
            toastId: "okSubscribe", // ✅ Prevent duplicate success toasts
          }
        );
      } else {
        // ✅ Corrected error message inside else block
        toast.error(
          "Failed to subscribe. Please try again with a valid email.",
          {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            theme: "colored",
            toastId: "failedSubscribe", // ✅ Prevent duplicate error toasts
          }
        );
      }
    } catch (err) {
      console.error("Subscription Error:", err);
      toast.error("An unexpected error occurred. Please try again later.", {
        // ✅ Handle network errors
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        theme: "colored",
        toastId: "networkError", // ✅ Prevent duplicate error toasts
      });
    }
  };

  useEffect(() => {
    const interval = setInterval(() => {
      setTimeLeft((prev) => {
        const totalSeconds =
          prev.days * 86400 +
          prev.hours * 3600 +
          prev.minutes * 60 +
          prev.seconds;
        const newTime = totalSeconds - 1;

        const days = Math.floor(newTime / 86400);
        const hours = Math.floor((newTime % 86400) / 3600);
        const minutes = Math.floor((newTime % 3600) / 60);
        const seconds = newTime % 60;

        return {
          days: days >= 0 ? days : 0,
          hours: hours >= 0 ? hours : 0,
          minutes: minutes >= 0 ? minutes : 0,
          seconds: seconds >= 0 ? seconds : 0,
        };
      });
    }, 1000);

    return () => clearInterval(interval);
  }, []);
  const handleInputChange = (e) => {
    setEmail(e.target.value);
  };

  const renderTime = (value, label) => {
    const percentage = (value / (label === "Days" ? 30 : 60)) * 100;

    return (
      <div className="timer-circle ">
        <div className="timer-container-circle">
          <svg className="timer-container-svg">
            <circle cx="50" cy="50" r="45"></circle>
            <circle
              cx="50"
              cy="50"
              r="45"
              style={{
                strokeDashoffset: `calc(282 - (282 * ${percentage}) / 100)`,
              }}
            ></circle>
          </svg>
          <div className="timer-value">{value.toString().padStart(2, "0")}</div>
        </div>
        <div className="timer-label">{label}</div>
      </div>
    );
  };
  return (
    <div className="footer-container">
      {/* Logo */}
      <div className="footer-logo-section">
        <img src={Logo1} alt="Logo" className="footer-logo" />
      </div>

      {/* Subscribe Section */}
      <form className="footer-subscribe-section" onSubmit={handleSubscribe}>
        <input
          type="email"
          placeholder="EMAIL ADDRESS"
          className="subscribe-input"
          value={email}
          required // ✅ Ensures the input is not empty before submission
          onChange={handleInputChange}
        />
        <button
          type="submit"
          onSubmit={handleSubscribe}
          className="subscribe-button"
        >
          SUBSCRIBE
        </button>
      </form>

      {/* <span>Countdown For Next Drop </span>
      <div className="timer-container">
        {renderTime(timeLeft.days, "DAYS")}
        {renderTime(timeLeft.hours, "HOURS")}
        {renderTime(timeLeft.minutes, "MINUTES")}
        {renderTime(timeLeft.seconds, "SECONDS")}
      </div> */}

      <CountdownTimer />

      {/* Footer Bottom */}
      <div className="footer-bottom">
        {/* Navigation Links */}
        <div className="footer-links">
          <Link to="/about">About us</Link>
          {/* <Link to="/refund">Refund Policy</Link> */}
          <Link to="/shippingPolicy">Shipping Policy</Link>
          <Link to="/privacyPolicy">Privacy Policy</Link>
          <Link to="/refunds">Refund Policy</Link>
          <Link to="/termsConditions">Terms & Conditions</Link>
          <Link to="/contact-us">Contact us</Link>
        </div>

        {/* Timer */}
        {/* <div className="footer-social-icons">
          <FaInstagram className="icon" />
          <FaTwitter className="icon" />
          <FaFacebook className="icon" />
          <IoLogoPinterest className="icon"/>
          
        </div> */}  

        <div className="footer-social-icons">
          <a
            href="https://instagram.com/yourstore"
            target="_blank"
            rel="noopener noreferrer"
            className="icon"
          >
            <FaInstagram className="icon" />
          </a>
          {/* <a
            href="https://facebook.com/yourstore"
            target="_blank"
            rel="noopener noreferrer"
            className="icon"
          >
            <FaFacebook className="icon" />
          </a> */}
          <a
            href="https://x.com/riymay24?s=11"
            target="_blank"
            rel="noopener noreferrer"
            className="icon"
          >
            <FaXTwitter className="icon" />
          </a>
          <a
            href="https://in.pinterest.com/riymay24/?invite_code=4eddf6359bf940bb8b813b1b44231c79&sender=959055820556061352"
            target="_blank"
            rel="noopener noreferrer"
            className="icon"
          >
            {/* <FaLinkedin className="icon" /> */}
            <IoLogoPinterest className="icon" />
          </a>
        </div>
      </div>

      <div className="footer-footer">
        <p>© 2026 Riymay. All rights reserved.</p>
        <img src={Logo2} alt="Logo" className="footer-logo-small" />
      </div>
    </div>
  );
};

export default Footer;
